<template>
  <v-app>
    <v-card>
      <Loading v-show="loading" message="Downloading..."></Loading>
      <div
        class="download-image"
        v-for="item in dashBoardLayout"
        :id="`${item.i}`"
        :key="item.i"
        v-bind:style="{
          width: `${downloadSizeInfo.get(item.i).width}px`,
        }"
      >
        <div class="download-graph-title">{{ item.graphTitle }}</div>
        <div class="graph-object">
          <DocumentFrequency
            v-if="item.graphType === 'documentFrequency'"
            :width="
              Math.min(
                downloadSizeInfo.get(item.i).width,
                downloadSizeInfo.get(item.i).height
              )
            "
            :height="
              Math.min(
                downloadSizeInfo.get(item.i).width,
                downloadSizeInfo.get(item.i).height
              )
            "
            :styles="{
              height: `${Math.min(
                downloadSizeInfo.get(item.i).width,
                downloadSizeInfo.get(item.i).height
              )}px`,
              width: `${Math.min(
                downloadSizeInfo.get(item.i).width,
                downloadSizeInfo.get(item.i).height
              )}px`,
            }"
          />
          <ApprovalDocumentTimeAverage
            v-else-if="item.graphType === 'approvalDocumentTimeAverage'"
            :width="downloadSizeInfo.get(item.i).width"
            :height="downloadSizeInfo.get(item.i).height"
            :styles="{
              width: `${item.w * 160 - 10}px`,
              height: `${downloadSizeInfo.get(item.i).height}px`,
            }"
          />
          <ApprovalTimeAverage
            v-else-if="item.graphType === 'approvalTimeAverage'"
            :width="downloadSizeInfo.get(item.i).width"
            :height="downloadSizeInfo.get(item.i).height"
            :styles="{
              width: `${item.w * 160 - 10}px`,
              height: `${downloadSizeInfo.get(item.i).height}px`,
            }"
          />
          <DocumentRejectionRate
            v-else-if="item.graphType === 'documentRejectionRate'"
            :width="downloadSizeInfo.get(item.i).width"
            :height="downloadSizeInfo.get(item.i).height"
            :styles="{
              width: `${downloadSizeInfo.get(item.i).width}px`,
              height: `${downloadSizeInfo.get(item.i).height}px`,
            }"
          />
          <UserRejectionRate
            v-else-if="item.graphType === 'userRejectionRate'"
            :width="downloadSizeInfo.get(item.i).width"
            :height="downloadSizeInfo.get(item.i).height"
            :styles="{
              width: `${downloadSizeInfo.get(item.i).width}px`,
              height: `${downloadSizeInfo.get(item.i).height}px`,
            }"
          />
          <DeviceFrequency
            v-if="item.graphType === 'deviceFrequency'"
            :width="
              Math.min(
                downloadSizeInfo.get(item.i).width,
                downloadSizeInfo.get(item.i).height
              )
            "
            :height="
              Math.min(
                downloadSizeInfo.get(item.i).width,
                downloadSizeInfo.get(item.i).height
              )
            "
            :styles="{
              height: `${Math.min(
                downloadSizeInfo.get(item.i).width,
                downloadSizeInfo.get(item.i).height
              )}px`,
              width: `${Math.min(
                downloadSizeInfo.get(item.i).width,
                downloadSizeInfo.get(item.i).height
              )}px`,
            }"
          />
          <Chart
            v-else
            :width="downloadSizeInfo.get(item.i).width"
            :height="downloadSizeInfo.get(item.i).height"
            :styles="{
              width: `${downloadSizeInfo.get(item.i).width}px`,
              height: `${downloadSizeInfo.get(item.i).height}px`,
            }"
          />
        </div>
        <div class="download-graph-description">
          {{ item.graphDescription }}
        </div>
      </div>
      <v-btn
        color="green darken-1"
        text
        style="visibility: hidden"
        @click="downloadDashBoardGraphs"
        >Download</v-btn
      >
    </v-card>
  </v-app>
</template>

<script>
import Chart from "../Graphs/Category2/ChartSample";
import DocumentFrequency from "../Graphs/Category1/DocumentFrequency";
import ApprovalDocumentTimeAverage from "../Graphs/Category1/ApprovalDocumentTimeAverage";
import ApprovalTimeAverage from "../Graphs/Category1/ApprovalTimeAverage";
import DocumentRejectionRate from "../Graphs/Category1/DocumentRejectionRate";
import UserRejectionRate from "../Graphs/Category1/UserRejectionRate";
import DeviceFrequency from "../Graphs/Category1/DeviceFrequency";
import domtoimage from "dom-to-image";
import Loading from "../Loading";
import JsZip from "jszip";
export default {
  computed: {
    selectedDashBoard: {
      get() {
        return this.$store.getters["individual/selectedDashBoard"];
      },
    },
    dashBoards: {
      get() {
        return this.$store.getters["individual/dashBoards"];
      },
    },
    downloadSizeInfo() {
      return this.$store.getters["downloadsize/downloadSizeInfo"];
    },
  },
  created() {
    for (var i = 0; i < this.dashBoards.length; i++) {
      if (this.dashBoards[i].dashBoardId === this.selectedDashBoard) {
        this.editingDashBoardIndex = i;
        break;
      }
    }
    this.dashBoardLayout = JSON.parse(
      JSON.stringify(
        this.dashBoards[this.editingDashBoardIndex].dashBoardLayout
      )
    );
  },
  mounted() {
    //TODO 画面のレンダリングが終了してから処理を行うように変える
    setTimeout(() => {
      this.downloadDashBoardGraphs();
    }, 1000);
  },
  components: {
    Loading,
    Chart,
    DocumentFrequency,
    ApprovalDocumentTimeAverage,
    ApprovalTimeAverage,
    DocumentRejectionRate,
    UserRejectionRate,
    DeviceFrequency,
  },
  methods: {
    async downloadDashBoardGraphs() {
      // ダウンロード処理
      await this.saveImage();

      // ダウンロード終了時元の画面に戻る
      // saveImageが完了してから元の画面に戻るように非同期処理にする
      this.$router.push({ path: "/" });
    },
    async saveImage() {
      let promises = [];
      let images = [];
      for (var i = 0; i < this.dashBoardLayout.length; i++) {
        var node = document.getElementById(this.dashBoardLayout[i].i);
        // DOM要素をdomtoimageのtoPNGに渡すと結果がPromiseで返ってくる
        promises.push(
          await domtoimage
            .toPng(node, {
              bgcolor: "rgb(255,255,255)",
              style: {
                width: this.imgWidth,
                padding: "none",
                margin: "none",
                border: "none",
              },
            })
            .then(function (dataUrl) {
              // dataUrlが返ってくるのでImageを生成し生成した画像を読み込む
              const img = new Image();
              img.src = dataUrl;
              img.fileName = "graph" + i + ".png";
              images.push(img);
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.log(error);
            })
        );
      }
      Promise.all(promises).then((values) => {
        this.generateImagesZip(images);
        return;
      });
    },
    generateImagesZip(images) {
      let zip = new JsZip();

      // フォルダ作成
      const folderName = "Graphs";
      let folder = zip.folder(folderName);

      // フォルダ下に画像を格納
      images.forEach((image) => {
        if (image.src && image.fileName) {
          folder.file(image.fileName, image.src.split(",")[1], {
            base64: true,
          });
        }
      });

      // zip を生成
      zip.generateAsync({ type: "blob" }).then((blob) => {
        // ダウンロードリンクを 生成
        let dlLink = document.createElement("a");

        // blob から URL を生成
        const dataUrl = URL.createObjectURL(blob);
        dlLink.href = dataUrl;
        dlLink.download = `${folderName}.zip`;

        // 設置/クリック/削除
        document.body.insertAdjacentElement("beforeEnd", dlLink);
        dlLink.click();
        dlLink.remove();

        // オブジェクト URL の開放
        setTimeout(function () {
          window.URL.revokeObjectURL(dataUrl);
        }, 1000);
      });
    },
  },
  data() {
    return {
      loading: true,
      dashBoardLayout: {},
      editingDashBoardIndex: 0,
      activeColor: "red",
      fontSize: 30,
    };
  },
};
</script>

<style scoped>
.download-graph-title,
.download-graph-description {
  font-size: 16px;
  padding: 2px;
}

.download-all {
  background-color: white;
  z-index: 1;
  width: 100%;
  height: 100%;
}
</style>
